<ng-container>
  <div [@routePopupAnimation]="prepareRoute(outlet)" class="popup_router-outlet">
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
</ng-container>
